module.exports = __webpack_public_path__ + "static/stopklatka-1-93390eb20aa33d147539927202ab7638.jpg";